import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import { ArrowLeft } from 'lucide-react';

import 'react-phone-input-2/lib/style.css';
import AuthLayout from '../../shared/components/AuthLayout';
import Button from '../../shared/components/Button';
import OverlayLoader from '../../components/Loader/OverlayLoader';
import loginImage from '../../assets/images/login.png';
import { AUTH_STACK } from '../../utils/screenNames';
import { forgotPassword } from '../../redux/actions/authActions';

/**
 * ForgotPasswordWithMobile Page - Refactored with Tailwind CSS
 * Send password reset code to mobile number
 */
function ForgotPasswordWithMobile() {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [telephone, setTelephone] = useState('');
  const [error, setError] = useState('');

  /**
   * Handle password reset request
   */
  const handleResetPassword = async () => {
    if (!telephone) {
      setError('Please enter your phone number');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      await forgotPassword(
        null,
        `+${telephone}`,
        () => {
          setIsLoading(false);
          navigate(AUTH_STACK.RESET_PASSWORD_WITH_MOBILE, {
            state: { telephone: `+${telephone}` },
          });
        },
        () => {
          setIsLoading(false);
          setError('Failed to send reset code. Please try again.');
        }
      );
    } catch (error) {
      setIsLoading(false);
      setError('An error occurred. Please try again.');
    }
  };

  if (isLoading) {
    return <OverlayLoader />;
  }

  return (
    <div className="relative w-screen h-screen bg-bg-dark">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="absolute top-6 left-6 z-20 flex items-center gap-2 text-shaded-text hover:text-[#FEFCEB] transition-colors"
      >
        <ArrowLeft className="w-5 h-5" />
        <span className="font-proxima text-sm">Back</span>
      </button>

      {/* Main Content */}
      <AuthLayout
        heroImage={loginImage}
        title="Reset your password"
        subtitle="Enter the mobile number you used when creating an account with Clubbie."
      >
        {/* Phone Input */}
        <div className="w-full">
          <PhoneInput
            country={'gb'}
            value={telephone}
            onChange={(phone) => setTelephone(phone)}
            containerClass="w-full"
            inputClass="!w-full !h-12 !bg-blue-shade-8 !text-[#FEFCEB] !border-blue-shade-7 !rounded-clubbie !font-proxima"
            buttonClass="!bg-blue-shade-7 !border-blue-shade-7 !rounded-l-clubbie"
            dropdownClass="!bg-blue-shade-8 !text-[#FEFCEB]"
          />
          {error && <p className="mt-2 text-sm text-red-500">{error}</p>}
        </div>

        {/* Reset Button */}
        <Button
          variant="primary"
          size="lg"
          onClick={handleResetPassword}
          className="w-full mt-6"
          disabled={!telephone}
        >
          Reset password
        </Button>
      </AuthLayout>
    </div>
  );
}

export default ForgotPasswordWithMobile;
